import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

// Send a request to the login URL. When using JWT, will just probably uncomment these lines
// const login = (creds) => {
//   let token = btoa(creds.name + ':' + creds.password)
//   let config = {
//     method: 'post',
//     url: LOGIN_URL,
//     responseType: 'json',
//     headers: {
//       'Authorization': 'Basic ' + token
//     },
//     credentials: true
//   }
//   return Vue.http(config)
// }

const getAutenticacaoUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth',
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getPermissoesUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth/permissoes',
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getConfiguracoesUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const alterarConfiguracoesUsuario = (payload) => {
  let config = {
    method: 'post',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true,
    body: payload
  }
  return Vue.http(config)
}

export default {
  getAutenticacaoUsuario,
  getPermissoesUsuario,
  getConfiguracoesUsuario,
  alterarConfiguracoesUsuario
}



// WEBPACK FOOTER //
// ./src/utils/auth.js